















































import {
	computed,
	defineComponent,
	ref,
	Ref,
	watchEffect,
} from '@vue/composition-api';
import { Size } from '@front-app/components/constants';
import { EventV2 } from '@front-app/services/EventsApi/EventModel';
import { SearchOption } from '@front-app/components/search/useSearch';
import { getEventV2ById } from '@front-app/services/EventsApi/EventsApi';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { useHighlightsInput } from '@front-app/modules/group/highlights/hooks/useHighlightsInput';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import SearchGroupEvents from '@front-app/components/inputs/SearchGroupEvents.vue';
import EventDates from '@front-app/modules/events/components/EventDates.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import { BUTTON_EDITOR_PROPS } from './buttonEditor';
import BaseButtonEditor from './BaseButtonEditor.vue';

export default defineComponent({
	components: {
		BaseButtonEditor,
		FormSection,
		FormLabel,
		SearchGroupEvents,
		EventDates,
		LoaderState,
	},
	props: BUTTON_EDITOR_PROPS,
	setup(props, ctx) {
		const useInput = useHighlightsInput(ctx, computed(() => props.value));
		// Event search
		const selectedEvent: Ref<EventV2 | undefined> = ref(undefined);
		const handleEventSelected = (event: SearchOption<EventV2>) => {
			selectedEvent.value = event.original;
			useInput.doMetaInput({
				groupId: props.group.id,
				eventId: event.original.id,
			});
		};
		watchEffect(async () => {
			const newId = props.value.meta.eventId;
			if (newId && newId !== selectedEvent.value?.id) {
				// Fetch the file and save
				selectedEvent.value = await getEventV2ById(newId);
			}
		});
		// END Event search
		return {
			DropdownPosition,
			selectedEvent,
			handleEventSelected,
			Size,
		};
	},
});
